import { useLanguage } from "@/contexts/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { OrganizersSection2026 } from "@/components/sections/OrganizersSection2026";
import { Card, CardContent } from "@/components/ui/card";

const Schedule2026 = () => {
  const { t, language } = useLanguage();

  const scheduleData = [
    {
      time: "9h00-9h30",
      fr: "Accueil des participants",
      en: "Participant Registration"
    },
    {
      time: "9h30-10h00",
      title: { fr: "Mot de bienvenue", en: "Welcome Address" },
      speakers: [
        "Saad Bouh CHEIKH EL MEHDI – Directeur de l'ISCAE Nouakchott",
        "Dhafer SAIDANE – Président de l'AFN",
        "Mohamed El Hanchi MOHAMED SALEH – Délégué Général de l'APBM",
        "Mohamed Vall EL ALEM – Secrétaire Général de l'Union des Banques Maghrébines",
        "Nabil JEDLANE – Vice-président de l'AFN et président du Conseil scientifique"
      ]
    },
    {
      time: "10h00-10h15",
      title: { fr: "Ouverture officielle", en: "Official Opening" },
      speakers: [
        {
          fr: "Mot du Ministre de l'Enseignement supérieur et de la Recherche scientifique",
          en: "Address by the Minister of Higher Education and Scientific Research"
        }
      ]
    },
    {
      time: "10h15-10h30",
      title: { fr: "Conférence inaugurale", en: "Inaugural Conference" },
      speakers: [
        "Abdessalam Ould Mohamed SALEH – Ancien Ministre de l'Energie et de l'Économie"
      ],
      special: {
        fr: "Le nexus Energie-développement : mobiliser les énergies renouvelables pour accélérer la croissance et le développement en Afrique",
        en: "The Energy-Development Nexus: mobilizing renewable energy to accelerate growth and development in Africa"
      }
    },
    {
      time: "10h30-10h45",
      fr: "Pause-café",
      en: "Coffee Break"
    },
    {
      time: "10h45-12h00",
      title: {
        fr: "Table ronde 1 : Quelle énergie renouvelable et quel mode de financement pour la Mauritanie ?",
        en: "Round Table 1: Which renewable energy and which financing model for Mauritania?"
      },
      panelists: {
        chair: "Président de séance : Taleb KHYAR CHEIKH MALAININE - Directeur Général de l'Agence Nationale de la Recherche Scientifique et de l'Innovation",
        members: [
          "• Mamadou Amadou KANE – Chargé de mission au ministère de l'Energie et du Pétrole, responsable des politiques et stratégies énergétiques",
          "• Khroumbaly LEHBIB – Directeur Général de SOMELEC",
          "• Thierno Seydou Nourou SY – Président et Fondateur de Nourou Financial Consulting (NFC) Dakar-Sénégal – De la finance verte à la souveraineté financière : repenser le financement de la transition énergétique en Afrique",
          "• El Moustapha Sidi Mohamed – Economiste et Enseignant chercheur à l'ISCAE de Nouakchott – Le financement durable en Mauritanie : défis et opportunités",
          "• Zekaria MOHAMED SALEM – Expert-comptable associé du cabinet AFC – Les risques liés au financement de la transition énergétique pour un investisseur dans le secteur financier"
        ]
      }
    },
    {
      time: "12h00-12h15",
      fr: "Signature de convention AFN - ISCAE Nouakchott\nPhoto de famille",
      en: "AFN - ISCAE Nouakchott Convention Signing\nFamily Photo",
      multiline: true
    },
    {
      time: "12h15-13h15",
      title: {
        fr: "Table ronde 2 : IA, métrique, inclusion sociale et financière",
        en: "Round Table 2: AI, metrics, social and financial inclusion"
      },
      panelists: {
        chair: "Président de séance : Maher GASSAB – Professeur à l'ESC Tunis",
        members: [
          "• Dhafer SAIDANE – Professeur à SKEMA BS, Sana BEN ABDALLAH – Professeure à FSEG Sfax et Brahim JAOUAD – DG de Sindbad Group – Comment assurer la transition énergétique : méthodes et stratégies ?",
          "• Mohamed Amine ISSAMI – Professeur à l'ISCAE Casa – De la métrique à l'impact : comment l'IA peut démocratiser l'accès au financement durable en Afrique",
          "• Menny EL BAH – Professeur à l'université Nouakchott – De l'énergie à la stabilité : comment l'hydrogène vert peut transformer l'inclusion et la sécurité au Sahel"
        ]
      }
    },
    {
      time: "13h15-14h30",
      fr: "Pause déjeuner",
      en: "Lunch Break"
    },
    {
      time: "14h30-16h30",
      title: {
        fr: "Ateliers de recherche",
        en: "Research Workshops"
      },
      panelists: {
        chair: "Animés par : Maher GASSAB, Dhafer SAIDANE, Amine ISSAMI, Nabil JEDLANE, Sana BEN ABDALLAH, Mohamed Lemine IDOUMOU, Saad Bouh REGAD",
        members: [
          "• Saoussen BEN CHEIKH – Chercheuse & entrepreneuse sociale, Fondatrice MENA-can – Transition énergétique en Mauritanie : compléter les grands projets par des écosystèmes ascendants durables",
          "• Abdou MBAYE – University of Pau et des Pays de l'Adour – Test de résistance climatique : une approche financière",
          "• Mody WASSA – Fondateur d'Énergielys et membre du comité scientifique FORA'ESS & Abd Dayem Sidi Mohamed NAVAE – Docteur en sciences économiques – Financement de la transition énergétique et innovation en Mauritanie. Rôle des startups, FinTech et CleanTech",
          "• EL Ghezaly Hamada SOUEIDI – Higher School of Commerce of Tunisia, UMA – ESCT – Does governance moderate the impact of digitalization on financial inclusion in Africa? An empirical investigation",
          "• Oumar Mohamed DAOUD – URMCD – Impacts du changement climatique sur l'économie mauritanienne et la nécessité de promouvoir la transition vers les énergies renouvelables",
          "• Amal BEN SALHA – Higher School of Commerce of Tunisia, UMA ESCT – Sustainable Finance for a Fair Green Transition: An Economic Perspective on the Inequality-Urbanization-Emissions Nexus (en ligne)",
          "• Hassan TAMBOURA – Professeur Associé au CESAG/Dakar, Sénégal – Le mécanisme de financement innovant pour un développement durable à l'épreuve des faits : une présentation synoptique dans le contexte de l'UEMOA (en ligne)"
        ]
      }
    },
    {
      time: "16h30-17h30",
      fr: "• Recommandations des 4èmes Rencontres de la Finance Durable\n• Réunion annuelle de l'AFN/OAFD",
      en: "• Recommendations of the 4th Sustainable Finance Meetings\n• Annual AFN/OAFD Meeting",
      multiline: true
    }
  ];

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="hero-gradient min-h-[60vh] flex items-center justify-center pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-gray-600 mb-4 italic">{t('event.patronage')}</p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-4">
            {t('event.title')}
          </h1>
          <p className="text-2xl sm:text-3xl text-gray-600 mb-4">
            {t('event.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <div className="text-lg font-semibold">{t('event.date')}</div>
            <div className="hidden sm:block">•</div>
            <div className="text-lg font-semibold">{t('event.location')}</div>
          </div>
        </div>
      </section>

      <OrganizersSection2026 />

      {/* Schedule Content */}
      <section className="section-padding bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-2">
            {language === 'fr' ? 'Programme' : 'Programme'}
          </h2>
          <p className="text-center text-gray-600 mb-8">
            {language === 'fr'
              ? "Lieu : Hôtel Sheraton Nouakchott"
              : "Venue: Sheraton Hotel Nouakchott"}
          </p>
          <div className="space-y-8">
            {scheduleData.map((item, index) => (
              <Card key={index} className="overflow-hidden">
                <CardContent className="p-6">
                  <div className="flex flex-col md:flex-row gap-4">
                    <div className="md:w-1/6">
                      <div className="text-lg font-semibold text-primary">{item.time}</div>
                    </div>
                    <div className="md:w-5/6">
                      {item.title ? (
                        <h3 className="text-xl font-semibold mb-2">
                          {language === 'fr' ? item.title.fr : item.title.en}
                        </h3>
                      ) : (
                        <h3 className={`text-xl font-semibold mb-2 ${item.multiline ? 'whitespace-pre-line' : ''}`}>
                          {language === 'fr' ? item.fr : item.en}
                        </h3>
                      )}

                      {item.speakers && (
                        <div className="mt-2 space-y-1">
                          {item.speakers.map((speaker: any, idx: number) => (
                            <p key={idx} className="text-gray-600 whitespace-pre-line">
                              {typeof speaker === 'string'
                                ? speaker
                                : language === 'fr' ? speaker.fr : speaker.en}
                            </p>
                          ))}
                        </div>
                      )}

                      {item.panelists && (
                        <div className="mt-3">
                          <p className="font-medium text-gray-800">{item.panelists.chair}</p>
                          <div className="mt-2 space-y-1 pl-4">
                            {item.panelists.members?.map((member, idx) => (
                              <p key={idx} className="text-gray-600 whitespace-pre-line">{member}</p>
                            ))}
                          </div>
                        </div>
                      )}

                      {item.special && (
                        <div className="mt-4 p-4 bg-gray-100 rounded-lg">
                          <p className="whitespace-pre-line text-gray-900 italic">
                            {language === 'fr' ? item.special.fr : item.special.en}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-center mb-4">{t('contact.title')}</h2>
          <p className="mb-2">{t('contact.info')}</p>
          <p className="text-primary font-medium">{t('contact.emails')}</p>
        </div>
      </section>
    </div>
  );
};

export default Schedule2026;
